import React, { useState, useContext } from "react";
import {
  Page,
  Card,
  Form,
  FormLayout,
  TextField,
  Button,
  InlineStack,
  Select,
} from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { ToastContext } from "../../global-contexts/Toast";

import { ValidateStoreBoxOrder } from "../../validators/StoreBoxes";
const StoreBoxOrderForm = ({ onSubmit, editable = true, boxes }) => {
  const [orderItems, setOrderItems] = useState([{ box: "", quantity: 1 }]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setToast } = useContext(ToastContext);

  const navigate = useNavigate();

  const handleQuantityChange = (index, value) => {
    const newOrderItems = [...orderItems];
    newOrderItems[index].quantity = value;
    setOrderItems(newOrderItems);
  };

  const handlePackagingSelection = (index, boxId) => {
    const newOrderItems = [...orderItems];
    newOrderItems[index].box = boxId;
    setOrderItems(newOrderItems);
  };

  const handleAddItem = () => {
    setOrderItems([...orderItems, { box: "", quantity: 1 }]);
  };

  const handleRemoveItem = (index) => {
    const newOrderItems = orderItems.filter((_, i) => i !== index);
    setOrderItems(newOrderItems);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    const payload = {
      orderItems: orderItems,
    };
    if (event) {
      event.preventDefault();
    }
    const validationErrors = ValidateStoreBoxOrder({ boxOrder: payload });

    if (validationErrors) {
      setToast({
        error: true,
        message: validationErrors.error,
        open: true,
      });
      setIsSubmitting(false);
      return;
    }

    try {
      await onSubmit(payload);
      navigate("/store-boxes");
    } catch (error) {
      console.error("Submission failed", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Page title="Create Store Box Order">
      <Form onSubmit={handleSubmit}>
        <Card title="Order Details" sectioned>
          <FormLayout>
            {orderItems.map((item, index) => (
              <InlineStack
                align="start"
                key={index}
                blockAlign="center"
                gap="300"
              >
                <Select
                  label="Packaging Size"
                  options={boxes.map((box) => ({
                    label: box.name,
                    value: box._id,
                  }))}
                  value={item.box}
                  onChange={(value) => handlePackagingSelection(index, value)}
                  placeholder="Select packaging type"
                  disabled={isSubmitting || !editable}
                />
                <TextField
                  label="Quantity"
                  value={item.quantity}
                  onChange={(value) => handleQuantityChange(index, value)}
                  type="number"
                  min={1}
                  disabled={isSubmitting || !editable}
                />
                <div style={{ marginTop: "22px" }}>
                  <Button
                    onClick={() => handleRemoveItem(index)}
                    variant="destructive"
                    disabled={isSubmitting || !editable}
                  >
                    Remove
                  </Button>
                </div>
              </InlineStack>
            ))}
            <Button
              onClick={handleAddItem}
              disabled={isSubmitting || !editable}
              variant="secondary"
            >
              Add Item
            </Button>
          </FormLayout>
        </Card>
        <br />
        <InlineStack align="start">
          <Button
            type="submit"
            loading={isSubmitting}
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting || orderItems.length === 0 || !editable}
          >
            Submit Order
          </Button>
        </InlineStack>
      </Form>
    </Page>
  );
};

export default StoreBoxOrderForm;
